import { c as _c } from "react/compiler-runtime";
import arrayToSentence from 'array-to-sentence';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'shared/button';
import EmptyState from 'shared/empty-state';
import { useSystemPlans } from 'shared/redux/system-plans/hooks';
import { FEATURES } from 'shared/utils/constants';
import { openChangePlanModal } from './redux/globals/actions';
const Upsell = t0 => {
  const $ = _c(18);
  const {
    feature
  } = t0;
  const dispatch = useDispatch();
  const businessId = useSelector(_temp);
  let t1;
  if ($[0] !== businessId) {
    t1 = {
      businessId
    };
    $[0] = businessId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const plans = useSystemPlans(t1);
  let t2;
  if ($[2] !== feature || $[3] !== plans) {
    let t3;
    if ($[5] !== feature) {
      t3 = (acc, curr) => {
        if (curr.features.includes(feature)) {
          acc.push(curr.name);
        }
        return acc;
      };
      $[5] = feature;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = plans.reduce(t3, []);
    $[2] = feature;
    $[3] = plans;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const featurePlans = t2;
  let t3;
  if ($[7] !== featurePlans) {
    t3 = arrayToSentence(featurePlans, {
      lastSeparator: " and "
    });
    $[7] = featurePlans;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const featurePlansToText = t3;
  const featureLabel = FEATURES[feature];
  const verb = featureLabel.endsWith("s") ? "are" : "is";
  let t4;
  if ($[9] !== featureLabel) {
    t4 = featureLabel.toLowerCase();
    $[9] = featureLabel;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = `You don't have ${t4} enabled on your plan`;
  const t6 = `${featureLabel} ${verb} only available on ${featurePlansToText} subscriptions`;
  let t7;
  if ($[11] !== businessId || $[12] !== dispatch) {
    t7 = <Button onClick={() => dispatch(openChangePlanModal(businessId))}>Upgrade now</Button>;
    $[11] = businessId;
    $[12] = dispatch;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = <><EmptyState heading={t5} subheading={t6} callToAction={t7} /></>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
export default Upsell;
function _temp(state) {
  return state.userPreferences.currentBusinessId;
}